import { render } from "./ModalEditPersonalData.vue?vue&type=template&id=176fa670"
import script from "./ModalEditPersonalData.vue?vue&type=script&lang=js"
export * from "./ModalEditPersonalData.vue?vue&type=script&lang=js"

import "./ModalEditPersonalData.vue?vue&type=style&index=0&id=176fa670&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__